"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FullPageLoaderHandler = {
  currentLoader: null,
  register: function register(loader) {
    this.currentLoader = loader;
  },
  unregister: function unregister() {
    this.currentLoader = null;
  },
  isShowing: function isShowing() {
    return this.currentLoader.isShowing();
  },
  show: function show() {
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (this.currentLoader === null) {
      return;
    }

    if (newState !== null) {
      this.currentLoader.setNewState(newState);
    }

    this.currentLoader.show();
  },
  hide: function hide() {
    if (this.currentLoader === null || !this.isShowing()) {
      return;
    }

    this.currentLoader.hide();
  }
};
var _default = FullPageLoaderHandler;
exports["default"] = _default;